import React, { useEffect, useState } from "react";
import Pettycashdetailstab from "../pettycash/Pettcashdetailtab";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button } from "@mui/material";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbsUpDownOutlinedIcon from "@mui/icons-material/ThumbsUpDownOutlined";
import formatDate from "../../common/Formatdate";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import { BlinkBlur } from "react-loading-indicators";
import formatDateAndTime from '../../common/formatDateAndTime'

function createData(
  Stage,
  pettycashid,
  bookingid,
  raisedon,
  requestedby,
  amount,
  approvedby,
  type,
  status,
  // city,
  // hub,
  action
) {
  return {
    Stage,
    pettycashid,
    bookingid,
    raisedon,
    requestedby,
    amount,
    approvedby,
    type,
    status,
    // city,
    // hub,
    action,
  };
}

const Viewallpettycash = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const pettyCashStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  const pettyCashStatusTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  delete pettyCashStatusTypes?.inverted;
  const pettyCashType = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const today = new Date();
  today.setHours(23, 59, 59, 999); // Clear time to midnight

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const [tableData, setTableData] = useState([]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [openTab, setOpenTab] = useState(false); // for total rows from backend

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // default 20 per page
  const [totalCount, setTotalCount] = useState(0); // for total rows from backend
  const [loading, setLoading] = useState(false);
  const [executiveId, setExecutiveId] = useState(profile?.id);

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const getTableData = async (
    customPage = page,
    customRowsPerPage = rowsPerPage
  ) => {
    setLoading(true);

    try {
      const offset = customPage * customRowsPerPage;

      let query = `limit=${customRowsPerPage}&offset=${offset}&createdBy=${executiveId}`;

      const response = await fetch(`${apiUrl}/api/pettycashes?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        // setVehicleId(null);
        // setStatusType(null);
        // setExecutiveId(null);
        setTableData(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching petty cash Table Data:", error);
    }
  };

  useEffect(() => {
    getTableData();
  }, []);

  const columns = [
    { id: "Stage", label: "Stage", minWidth: 50 },
    { id: "pettycashid", label: "Petty Cashid", minWidth: 70 },
    { id: "bookingid", label: "Booking Id", minWidth: 70 },
    {
      id: "raisedon",
      label: "Raised On",
      minWidth: 120,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "requestedby",
      label: "Requested By",
      minWidth: 150,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "amount",
      label: "Amount",
      minWidth: 110,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "approvedby",
      label: "Approved By",
      minWidth: 150,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "type",
      label: "Type",
      minWidth: 110,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "status",
      label: "Status",
      minWidth: 110,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    // {
    //   id: "city",
    //   label: "City",
    //   minWidth: 110,
    //   align: "right",
    //   format: (value) => value.toFixed(2),
    // },
    // {
    //   id: "hub",
    //   label: "Hub",
    //   minWidth: 110,
    //   align: "right",
    //   format: (value) => value.toFixed(2),
    // },
    {
      id: "action",
      label: "Action",
      minWidth: 90,
      align: "right",
      format: (value) => value.toFixed(2),
    },
  ];

  const rows = tableData.map((item) =>
    createData(
      pettyCashStatus[item?.pettyCashStatus] === "Cash Completed" ? (
        <ThumbUpOffAltIcon sx={{ color: "#46b051" }} />
      ) : pettyCashStatus[item?.pettyCashStatus] === "Verified" ? (
        <ThumbsUpDownOutlinedIcon sx={{ color: "#5e73db" }} />
      ) : pettyCashStatus[item?.pettyCashStatus] === "Requested" ? (
        <HourglassEmptyOutlinedIcon sx={{ color: "#f7a202" }} />
      ) : (
        <ThumbDownOffAltIcon sx={{ color: "#cf4c64" }} />
      ),
      item?.id,
      item?.bookingCode
        ? item?.bookingCode
        : item?.bookingId
        ? item?.bookingId
        : "N/A",
      formatDateAndTime(item?.createdAt),
      item?.requestBy || "-",
      item?.amount || "-",
      item?.approvedBy ? item?.approvedBy : "/",
      pettyCashType[item?.cashFor],
      pettyCashStatus[item?.pettyCashStatus],
      // item?.cityName || "-",
      // item?.hubName || "-",
      "View"
    )
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getTableData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getTableData(0, newRowsPerPage);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 4,
  };

  return (
    <>
      {!openTab ? (
        <div className="max-w-screen h-full backdrop-blur-sm sm:px-6 md:px-0">
          <div className="mt-6 flex justify-between">
            <h1 className="font-bold text-xl sm:text-2xl">Petty Cash List</h1>
          </div>

          {loading ? (
            <div className="flex flex-col items-center h-screen justify-center">
              <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
            </div>
          ) : (
            <div className="overflow-y-hidden hide-scrollbar w-full">
              <Paper
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  marginTop: 4,
                  boxShadow: 6,
                  borderRadius: 2,
                  paddingBottom: 4,
                }}
              >
                <TableContainer
                  sx={{
                    overflowX: { xs: "auto", sm: "auto" },
                    overflowY: "hidden", // disable Y scroll
                  }}
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            sx={{
                              border: "1px solid #e0e0e0", // light gray border
                              backgroundColor: "#f5f5f5", // optional: subtle header background
                            }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.code}
                            // sx={{
                            //   borderBottom: "1px solid #e0e0e0", // light row separator
                            // }}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  className="cursor-pointer"
                                  key={column.id}
                                  align={column.align}
                                  // onClick={() => handleViewClick(row)}
                                  // sx={{ borderLeft: "1px solid #e0e0e0" }}
                                >
                                  {column.id === "action" ? (
                                    <Button
                                      size="small"
                                      variant="contained"
                                      onClick={() => handleViewClick(row)}
                                    >
                                      View
                                    </Button>
                                  ) : column.format &&
                                    typeof value === "number" ? (
                                    column.format(value)
                                  ) : (
                                    value
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 30]} // disables the dropdown
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage} // fixed
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={(event) => {
                    handleChangeRowsPerPage(event);
                  }} // no-op
                />
              </Paper>
            </div>
          )}
        </div>
      ) : (
        <Pettycashdetailstab
          selectedRow={selectedRow}
          openTab={openTab}
          setSelectedRow={setSelectedRow}
          setOpenTab={setOpenTab}
          getTableData={getTableData}
        />
      )}
    </>
  );
};

export default Viewallpettycash;
